import { createContext, Dispatch } from 'react'
import { Action, ContextState } from '../types/context-types'

interface GlobalStateContextProps {
  state: ContextState
  dispatch: Dispatch<Action>
}

const NoteContext = createContext<GlobalStateContextProps>({} as GlobalStateContextProps)

export default NoteContext